const items = [
  'UGC-Approved Online Degrees', '30+ Expert Counsellors', 'NAAC A++ Universities',
  'PAN-India Student Support', 'Amity University Partner', 'DY Patil University Partner',
  'Zero-Hassle Admissions', 'Working Professional Friendly', '400+ Students Enrolled',
  '4.9★ Google Rated', 'Govt. Recognised Programs', 'Free Expert Counselling',
];

const doubled = [...items, ...items];

export default function Marquee() {
  return (
    <div style={{ background: 'var(--yellow)', overflow: 'hidden' }}>

      {/* Row 1 — text marquee */}
      <div style={{ padding: '14px 0', borderBottom: '1px solid rgba(11,31,74,0.1)' }}>
        <div style={{
          display: 'flex', whiteSpace: 'nowrap',
          animation: 'marqueeScroll 32s linear infinite',
          width: 'max-content',
        }}>
          {doubled.map((item, i) => (
            <span key={i} style={{
              display: 'inline-flex', alignItems: 'center', gap: 12,
              padding: '0 36px', fontSize: 13, fontWeight: 700, color: 'var(--navy)',
            }}>
              {item}
              <span style={{ opacity: 0.35, fontSize: 10 }}>✦</span>
            </span>
          ))}
        </div>
      </div>




      <style>{`
        @keyframes marqueeScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div >
  );
}